import { useCallback } from "react";
import { useNavigate } from "@tanstack/react-router";
import { ACTIVE_PROJECT_SLUG_KEY } from "@/lib/local-storage.consts";

export function useGoToProject(workspaceSlug: string | undefined) {
  const navigate = useNavigate();

  const goToProject = useCallback(
    (projectSlug: string | undefined) => {
      if (!(workspaceSlug && projectSlug)) return;
      if (projectSlug === "/") {
        localStorage.removeItem(ACTIVE_PROJECT_SLUG_KEY);
        void navigate({ to: `/workspaces/${workspaceSlug}/projects` });
        return;
      }
      localStorage.setItem(ACTIVE_PROJECT_SLUG_KEY, projectSlug);
      void navigate({
        to: "/workspaces/$slug/projects/$projectSlug",
        params: { slug: workspaceSlug, projectSlug },
      });
    },
    [navigate, workspaceSlug],
  );

  return { goToProject };
}
